import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const contest = {
  fetchContest: lazyModuleMethod(() => import('./fetchContest'), 'default'),
  fetchContests: lazyModuleMethod(() => import('./fetchContests'), 'default'),
  createContest: lazyModuleMethod(() => import('./createContest'), 'default'),
  updateContest: lazyModuleMethod(() => import('./updateContest'), 'default'),
  deleteContest: lazyModuleMethod(() => import('./deleteContest'), 'default'),
}
